const devConfig = {
    // apiUrl: "http://app.mt.mika.avenla.fi/api",
    // apiUrl: "https://app.mt.mika.avenla.fi/api",
    // apiUrl: "https://app.minuntalo.local/api",
    // apiUrl: "https://minuntalo.in.avenla.fi/api",
    apiUrl: "https://app.minuntalo.fi/api",
};

const prodConfig = {
    // apiUrl: "http://app.mt.mika.avenla.fi/api",
    // serviceAddress: "ws://app.mt.mika.avenla.fi:9311/client",
    // apiUrl: "https://app.minuntalo.local/api",
    // apiUrl: "https://minuntalo.in.avenla.fi/api",
    // serviceAddress: "ws://api.mt.w14.avenla.fi:9311/client",
    apiUrl: "https://app.minuntalo.fi/api",
};


const config =
    process.env.NODE_ENV === "development" 
        ? devConfig
        : prodConfig;

export default config;
